import React, { useContext } from 'react';
import classNames from 'classnames';
import { Alert } from '@one-thd/sui-atomic-components';
import { Checkmark } from '@one-thd/sui-icons';
import Spinner from '../../../../shared/spinner/spinner';
import { modalBlurbs } from '../../../../../constants/NationalAccount';
import { NationalAccountContext } from '../../../../../contexts';
import { formErrorMessages } from '../../../../../constants/form-error-messages';

export const handleMultiLines = (text: any) => (
  <>
    <p>{text?.line1}</p>
    {text?.line2 && <p style={{ paddingTop: '32px' }}>{text?.line2}</p>}
  </>
);

export const ReturnError = () => {
  return (
    <Alert status="error">
      {formErrorMessages.agreementPricingCodeInvalid.message}
    </Alert>
  );
};

export const ReturnCheckBoxError = () => {
  return (
    <div data-testid="modalCheckBoxError">
      <Alert status="error">Please select the checkbox to enroll.</Alert>
    </div>
  );
};

export const ShowSpinner = (): JSX.Element => {
  return (
    <div className="spinner-div">
      <Spinner active />
    </div>
  );
};

export const ConfirmValidMessage = ({
  confirmMessage,
  doJustifyStart,
}: any): JSX.Element => {
  const confirmClasses = classNames('sui-flex sui-flex-col sui-align-center', {
    'sui-justify-start sui-pt-1': doJustifyStart,
    'sui-justify-center': !doJustifyStart,
  });
  return (
    <div
      data-testid="confirmValidMessage"
      className="sui-flex sui-flex-row sui-justify-start sui-align-center sui-text-base sui-font-bold sui-py-4 sui-text-success"
    >
      <div className={confirmClasses}>
        <Checkmark size="regular" color="current" />
      </div>
      <div className="sui-pl-4">{confirmMessage}</div>
    </div>
  );
};

const CodeDetailRow = ({ detailKey, detailValue }: any): JSX.Element => {
  return (
    <div className="sui-flex sui-flex-row sui-gap-8 sui-align-start sui-text-base sui-pb-4">
      <div className="sui-w-32 sui-font-bold">
        <p>{detailKey}</p>
      </div>
      <div>
        <p>{detailValue}</p>
      </div>
    </div>
  );
};

export const CodeDetailDescription = ({
  validResponseState,
  showModal,
}: any): JSX.Element => {
  const { currentAgreementCode } = useContext(NationalAccountContext) || {};
  return (
    <div
      data-testid="modalBodyFont"
      className="sui-flex sui-flex-col sui-justify-center sui-align-start NationalAccount__modalBodyFont"
    >
      {showModal && (
        <ConfirmValidMessage
          confirmMessage={modalBlurbs.confirm.validAgreementCode}
          doJustifyStart={false}
        />
      )}
      <div className="sui-flex sui-flex-col sui-justify-between sui-align-start">
        <CodeDetailRow
          detailKey={modalBlurbs.confirm.name}
          detailValue={
            !showModal || currentAgreementCode?.abbreviatedName
              ? currentAgreementCode?.abbreviatedName
              : validResponseState.agreementCodeEntered
          }
        />
        <CodeDetailRow
          detailKey={modalBlurbs.confirm.code}
          detailValue={
            !showModal || currentAgreementCode
              ? currentAgreementCode?.agreementName
              : validResponseState.agreementCodeNameEntered
          }
        />
        {!showModal && (
          <div>
            <CodeDetailRow
              detailKey={modalBlurbs.unenroll.enrollmentDate}
              detailValue={currentAgreementCode?.enrollmentDate}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export const CodeFullDetailDescription = ({ isModal }: any): JSX.Element => {
  const { currentAgreementCode } = useContext(NationalAccountContext);
  return (
    <div
      data-testid="modalBodyFont"
      className="sui-flex sui-flex-col sui-justify-center sui-align-start NationalAccount__modalBodyFont"
    >
      <div className="sui-flex sui-flex-col sui-justify-between sui-align-start">
        <CodeDetailRow
          detailKey={modalBlurbs.confirm.name}
          detailValue={currentAgreementCode?.abbreviatedName}
        />
        <CodeDetailRow
          detailKey={modalBlurbs.confirm.code}
          detailValue={currentAgreementCode?.agreementName}
        />
        {!isModal && (
          <>
            <CodeDetailRow
              detailKey={modalBlurbs.unenroll.enrollmentDate}
              detailValue={currentAgreementCode?.enrollmentDate}
            />
          </>
        )}
      </div>
    </div>
  );
};
